module.exports = __webpack_public_path__ + "static/media/slider_valid.f320f7d6.mp3";